export default __webpack_public_path__ + "static/media/KOD0007-min.eb7d34e2.webp";